import React from 'react';

import {Switch, Route} from 'react-router-dom';

import Radium from 'radium';

import ContactUs from './components/ContactUs';
import {Employers} from './components/Employers';
import {Home} from './components/Home';
import {Jobs} from './components/Jobs';
import {Dashboard} from './components/Layouts';
import {NotFound} from './components/Shared';
import Subscription from "./components/Subscriptions";
import Products from "./components/Products";
import Checkout from  "./components/Subscriptions/Checkout";
import Payment from  "./components/Subscriptions/Payment";
import SignUp from "./components/Subscriptions/SignUp";
import {UserRegistration, ForgotPassword, NewPassword} from './components/Users';
import {Dashboard as AdminDashboard} from './components/Admin/Dashboard';
import  Profiles  from './components/Employers/Profiles';

const styles = {
  marginTop: 76,
  background: 'white',
  color: '#333',
  minHeight: "100vh", // display the whole fold even if there is no data
}

const Main = (props) =>
  <main style={styles}>
    <Switch>
      <Route exact path='/employers/contact-us' render={() => (<ContactUs {...props}  />)}/>
      <Route exact path='/admin/analytics' render={() => (<AdminDashboard {...props}/>)}/>
      <Route path='/jobs' render={() => (<Jobs {...props}/>)}/>
      <Route path='/profiles' render={() => (<Profiles {...props}/>)}/>
      <Route path='/dashboard' render={() => (<Dashboard {...props}/>)}/>
      <Route path='/employers' render={() => (<Employers {...props}/>)}/>
      <Route exact path='/subscriptions' render={() => (<Subscription {...props} />)}/>
      <Route exact path='/products' render={() => (<Products {...props} />)}/>
      <Route exact path='/payment' render={() => (<Payment {...props}/>)}/>
      <Route exact path='/checkout' render={() => (<Checkout {...props}/>)}/>
      <Route exact path='/employer-signup' render={() => (<SignUp {...props} />)}/>
      <Route exact path='/' render={() => (<Home {...props}/>)}/>
      <Route exact path='/register' render={() => (<UserRegistration {...props}/>)}/>
      <Route exact path='/forgot-password' render={() => (<ForgotPassword {...props}/>)}/>
      <Route exact path='/password/:token' render={() => (<NewPassword {...props}  />)}/>
      <Route exact path='/contact-us' render={() => (<ContactUs {...props}  />)}/>
      <Route exact path='*' render={() => (<NotFound {...props}/>)}/>
    </Switch>
  </main>

export default Radium(Main);
